import { render, staticRenderFns } from "./NetworkWidget.vue?vue&type=template&id=04ed5e07&scoped=true"
import script from "./NetworkWidget.vue?vue&type=script&lang=js"
export * from "./NetworkWidget.vue?vue&type=script&lang=js"
import style0 from "./NetworkWidget.vue?vue&type=style&index=0&id=04ed5e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed5e07",
  null
  
)

export default component.exports